import React from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-unresolved
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import BaseModal from 'products/nomad_insurance/components/BaseModal';
import { ClaimTypeInfo } from '../ClaimTypeInfo';
import { ClaimAmountInfo } from '../ClaimAmountInfo';
import ClaimIDInfo from '../ClaimIDInfo';
import ClaimantInfo from '../ClaimantInfo';
import { ClaimInfos, NoteHeading, Note, DoneButton } from './styled';

const ClaimNoteModal = ({ claim, isOpen, onClose }) => {
  const { eobNumber, note, claimFullName, claimType } = claim;

  return (
    <BaseModal
      isOpen={isOpen}
      heading="Information about your claim"
      headerColor="porsche"
      onClose={onClose}
    >
      <ClaimInfos>
        <ClaimIDInfo eobNumber={eobNumber} />
        <ClaimantInfo claimFullName={claimFullName} />
        <ClaimTypeInfo claimType={claimType} />
        <ClaimAmountInfo claim={claim} />
      </ClaimInfos>
      <div>
        <NoteHeading>Comments:</NoteHeading>
        <Note>{note}</Note>
      </div>
      <DoneButton onClick={onClose} color="pickledBluewood">
        Done
      </DoneButton>
    </BaseModal>
  );
};

ClaimNoteModal.propTypes = {
  claim: PropTypes.any.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};

export default ClaimNoteModal;
